(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-de-pagina"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Badge pill en enlaces del footer — misma lógica que el header */
  function initFooterBadges() {
    document.querySelectorAll('.pf-nav-link').forEach(function (link) {
      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var m = node.textContent.match(/^(.*?)\s*\[([^\]]+)\]\s*$/);
        if (m) {
          node.textContent = m[1];
          var badge = document.createElement('span');
          badge.className = 'nav-badge';
          badge.textContent = m[2].toLowerCase();
          node.parentNode.insertBefore(badge, node.nextSibling);
          break;
        }
      }
    });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initFooterBadges)
    : initFooterBadges();
})();

  } catch(e) { console.error(e); }
})();
})();
